import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import React, { useEffect, useRef, useState } from 'react';
import Videodata from './VideoData';
import VideodataFr from './VideoDataFr';
import './VideoGallery.css';
import VideoItem from './VideoItem';
import VideoModal from './VideoModal';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@mui/material';
const useStyles = makeStyles({
  startdiv: {
    padding: '48px 0px',
    ['@media (max-width:768px)']: {
      padding: '24px 0px',
    },
  },
  rowtopdiv: {
    overflow: 'hidden',
    ['@media (min-width:768px)']: {
      marginTop: '32px',
    },
  },
  row: {
    display: 'flex',
    marginRight: '-15px',
    marginLeft: '-15px',
    flexWrap: 'wrap',
  },
  container: {
    ['@media (max-width: 425px)']: {
      paddingLeft: '5px !important',
      paddingRight: '4px !important',
    },
  },
});
function VideoGallery(props) {
  let data;
  const classes = useStyles();
  if (props.selectedLang === 'fr') {
    data = VideodataFr;
  } else {
    data = Videodata;
  }
  const [currentCategory, setCurrentCategory] = useState();
  const [categoryList, setCategoryList] = useState([]);
  const [videoModal, setVideoModal] = useState({ visible: false, url: '' });
  const setVideoModalStatus = (visible = false, url = '') =>
    setVideoModal({ visible: visible, url: url });
  const [showArrows, setShowArrows] = useState(false);
  const arrowRef = useRef(null);
  const addArrow = () => {
    if (arrowRef.current != null) {
      if (arrowRef.current.scrollWidth > arrowRef.current.offsetWidth) {
        setShowArrows(true);
      } else setShowArrows(false);
    }
  };
  useEffect(() => {
    let unique = [...new Set(data.map((video) => video.category))];

    setCategoryList(unique);
    setCurrentCategory(unique[0]);
    addArrow();
  }, []);

  window.addEventListener('resize', addArrow);

  function setCategory(category) {
    setCurrentCategory(category);
  }

  const scrollLeft = () => {
    arrowRef.current.scrollLeft -= 100;
  };

  const scrollRight = () => {
    arrowRef.current.scrollLeft += 100;
  };
  const { t } = useTranslation();
  return (
    <>
      <section className={classes.startdiv} id="videoGallery">
        <Container fixed className={classes.container}>
          <div className="section-title" style={{ marginBottom: '16px' }}>
            <h2>{t('sections-VideoGallery-VideoGallery-Head')}</h2>
            <p>{t('sections-VideoGallery-VideoGallery-para')}</p>
          </div>
          <div className="categories" style={{ marginBottom: '16px' }}>
            {/* {showArrows && (
              <ArrowLeftIcon
                onClick={scrollLeft}
                className="video-category-arrows"
                style={{ margin: '0px auto 16px 0px' }}
              />
            )} */}
            <div className="videogallery-category-wrapper" ref={arrowRef}>
              {categoryList.map((categoryItem, i) => {
                return (
                  <p
                    key={i}
                    className={
                      'category ' +
                      (currentCategory === categoryItem
                        ? 'active-category'
                        : '')
                    }
                    onClick={() => {
                      setCategory(categoryItem);
                    }}
                  >
                    {categoryItem}
                  </p>
                );
              })}
            </div>
            {/* {showArrows && (
              <ArrowRightIcon
                onClick={scrollRight}
                className=" video-category-arrows"
                style={{ margin: '0px auto 16px 0px' }}
              />
            )} */}
          </div>
        </Container>
        <Container fixed className={`videoItem ${classes.rowtopdiv}`}>
          <div className={`${classes.row}`}>
            {data.map((item, i) => {
              if (item.category === currentCategory) {
                return (
                  <VideoItem
                    // key={i}
                    data={item}
                    isservice={false}
                    onPlay={() => setVideoModalStatus(true, item.videoUrl)}
                    key={item.videoUrl}
                  />
                );
              } else {
                return '';
              }
            })}
          </div>
        </Container>
      </section>
      {videoModal.visible && (
        <VideoModal
          url={`${videoModal.url}?autoplay=1&enablejsapi=1&mute=1`}
          onClose={() => setVideoModalStatus(false)}
        />
      )}
    </>
  );
}

export default VideoGallery;
